import type { RouteObject } from 'react-router';
import { paths } from '@shared/config/paths';
import { DashboardPage } from './pages/DashboardPage';

/** Routes exposées par la feature « dashboard » à la coquille applicative. */
export const dashboardRoutes: RouteObject[] = [
  { path: paths.dashboard, element: <DashboardPage /> },
];
